import { useContext } from 'react';
import { ReadOnlyContext } from './ReadOnlyContext';

/**
 * Renders children only when the session is NOT read-only.
 * Use this to wrap any write-action UI (buttons, links, panels)
 * inside class components that can't use useContext directly.
 *
 * Usage:
 *   <WriteOnly>
 *     <Button onClick={this.onEdit}>Edit</Button>
 *   </WriteOnly>
 */
export const WriteOnly = ({ children }) => {
  const isReadOnly = useContext(ReadOnlyContext);
  return isReadOnly ? null : children;
};
